import React, { useState } from 'react'
import { Button, message, Upload, Form, Modal } from 'antd'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { InboxOutlined } from '@ant-design/icons'

const { Dragger } = Upload

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

const App = () => {
  const [fileList, setFileList] = useState([])
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [uploading, setUploading] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [blob, setBlob] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleCancelPreview = () => setPreviewOpen(false)
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    setPreviewImage(file.url || file.preview)
    setPreviewOpen(true)
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    )
  }
  const handleUpload = () => {
    const formData = new FormData()
    fileList.forEach(file => {
      formData.append('images', file.originFileObj)
    })
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/upload/pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob'
      })
      .then(res => {
        const blob = res.data
        setBlob(blob)
        // 创建一个URL，指向Blob对象
        const blobUrl = URL.createObjectURL(blob)
        setPdfUrl(blobUrl)
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch(error => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = () => {
    handleUpload()
  }
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    setIsModalOpen(false)
    saveAs(new Blob([blob], { type: 'application/pdf' }), '合并文档.pdf') // 设置下载文件名
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList)
  // 上传按钮属性
  const props = {
    multiple: true,
    onRemove: file => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: file => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error('只能上传jpg或png格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        message.error('上传文件最大10MB!')
        return false
      }
      return false
    },
    listType: 'picture-card',
    onChange: handleChange,
    onPreview: handlePreview,
    fileList
  }
  return (
    <>
      <Dragger {...props} style={{ marginBottom: 30 }}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖曳文件上传</p>
        <p className="ant-upload-hint">支持单图与多图上传，并且支持拖曳</p>
      </Dragger>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          wrapperCol={{
            offset: 9,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            loading={uploading}
            disabled={fileList.length < 1}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="转换结果"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="下载"
        cancelText="取消"
      >
        <iframe
          src={pdfUrl}
          title="pdf"
          style={{
            width: '100%',
            height: 400,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#ddd'
          }}
        ></iframe>
      </Modal>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancelPreview}
      >
        <img
          alt={previewTitle}
          style={{
            width: '100%'
          }}
          src={previewImage}
        />
      </Modal>
    </>
  )
}
export default App
